import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Api } from '@/core/api.js'

Vue.use(VueI18n)

const api = new Api()

const SUPPORTED_LOCALES = ['es', 'ca']

function normalizeLocale(raw) {
    if (!raw) return null
    return raw.toLowerCase().split('-')[0]
}

function detectBrowserLocale() {
    const raw =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage

    return normalizeLocale(raw)
}

function resolveInitialLocale() {
    const stored = normalizeLocale(localStorage.getItem('locale'))
    if (stored && SUPPORTED_LOCALES.includes(stored)) return stored
    
    const browser = detectBrowserLocale()
    if (browser && SUPPORTED_LOCALES.includes(browser)) return browser

    return 'es'
}

const defaultLocale = resolveInitialLocale()

const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: 'es',
    messages: {}
})

const loadedLanguages = []

i18n.loadLanguageAsync = async function (lang) {
    lang = normalizeLocale(lang) || 'es'

    const currentMessages = i18n.getLocaleMessage(lang) || {}
    const hasMessages = Object.keys(currentMessages).length > 0

    if (loadedLanguages.includes(lang) && hasMessages) {
        return setI18nLanguage(lang)
    }

    const response = await api.language(lang)
    i18n.setLocaleMessage(lang, response)

    if (!loadedLanguages.includes(lang)) loadedLanguages.push(lang)

    localStorage.setItem('locale', lang)
    return setI18nLanguage(lang)
}

export default i18n

function setI18nLanguage(lang) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}
